module.exports = __webpack_public_path__ + "img/柚子7.607f5b97.png";